export default process.env.AUTH_API_URL || 'https://backend.yapitahealth.com/api';
